// extracted by mini-css-extract-plugin
export default {"root":"Scope_root__LzL1K","scopeText":"Scope_scopeText__UmLAe","scopePre":"Scope_scopePre__QStzr","scopeDescription":"Scope_scopeDescription__nsKKE"};